/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import {Grid, Card, CardHeader, CardContent, CardActions, Typography} from "@material-ui/core";
import {withTranslation} from 'react-i18next';
import {useThemeData} from '../../context/ThemeDataContext'
import ProductDetailComponent from "./../../components/Product/ProductdetailComponent";
import GeneralButton from "../../components/Buttons";
import ProductPrice from "../../components/ProductPrice";
import ProductDiscountAlert from "../../components/ProductDiscountAlert"

function Product(props) {
    const {
        primary_color_3,
        primary_color_5,
        background_color_3,
        background_color_4
    } = useThemeData().themeData.site.theme;
    const { hide_category_side_bar } = useThemeData().modules;
    const product = props.product
    const data = props.data;
    const {category_id} = useThemeData().categoryData;
    const session_id = localStorage.getItem('session_id');
    const queryVars = props.queryVars;
    const quantity = props.quantity;
    const changeQuantity = props.changeQuantity;
    const productVariation = props.productVariation;
    const printType = props.printType;
    const handleColorChange = props.handleColorChange;
    const closePopup = props.closePopup;
    const updatePhotoFileName = props.updatePhotoFileName;
    const handlerFileNameEffect = props.handlerFileNameEffect;
    const handlerFileIdEffect = props.handlerFileIdEffect;
    const handlerTypeEffect = props.handlerTypeEffect;
    const handleCreateShoppingCart = props.handleCreateShoppingCart;
    const effectFileNameFor= props.effectFileNameFor;
    const effectFileNameBehind= props.effectFileNameBehind;
    const effectClear = props.effectClear;

    const handleNotShoppingCart = (e, product) => {
        e.preventDefault();
        e.stopPropagation();
        if(product.productdetail.productcategory.back_categorie!==null){
            props.history.push({
                pathname: `/shoppage/photo_id/${product.productdetail.photo_id}/${product.productdetail.productcategory.back_categorie}`,
                state: {
                    photo_id: product.productdetail.photo_id,
                    folder_id: product.productdetail.folder_id,
                    photo_file_name: product.productdetail.product_file,
                    categorie_id: product.productdetail.productcategory.back_categorie,
                },
            });
        }

    };

    if (props.type === 'one_product') {
        return (
            <Grid key={product.product_id} style={{
                width: `100%`,
            }}>
                <Card className="bg-light bottom-card" style={{
                    width: `100%`,
                }}>
                    <Grid container direction="row" className="no-full-margin-around">
                        <CardHeader
                            className="col-8 text-start"
                            style={{
                                backgroundColor: `${background_color_3}`,
                                color: `${primary_color_3}`
                            }}>
                            <Typography className="font-bold" variant="body1" component="p">
                                {product.productdetail.naam}
                            </Typography>
                        </CardHeader>
                        <CardHeader
                            className="col-4 text-end"
                            style={{
                                backgroundColor: `${background_color_4}`,
                                color: `${primary_color_5}`
                            }}>
                            <Typography className="font-bold price" variant="body1" component="div">
                                <ProductPrice price={product.productdetail.prijs} actionprice={product.productdetail.actie_prijs}></ProductPrice>
                            </Typography>
                        </CardHeader>
                    </Grid>
                    <Grid container direction="row" style={{
                        width: `100%`,
                    }}>
                        <CardContent className="card-body-and-footer col-12" style={{
                            width: `100%`,
                        }}>
                            <ProductDetailComponent
                                {...props}
                                updatePhotoFileName={updatePhotoFileName}
                                modulerights={props.modulerights}
                                product_id={product.product_id}
                                product_description={product.productdetail.description}
                                product_video={product.productdetail.youtube}
                                pakket_data={product.productlink.productpakketdetails[0].products}
                                category_id={product.productdetail.productcategory.categorie_id}
                                product_type={product.productdetail.product_type}
                                product_colors={product.productdetail.kleuren}
                                photo_file_name={product.productdetail.product_file}
                                product_image={product.productdetail.afbeelding}
                                product_format={product.productdetail.product_format}
                                photo_id={queryVars.photo_id}
                                session_id={session_id}
                                handleColorChange={handleColorChange}
                                productVariation={productVariation}
                                printType={printType}
                                changeQuantity={changeQuantity}
                                quantity={quantity}
                                fileNameEffect={handlerFileNameEffect}
                                fileIdEffect={handlerFileIdEffect}
                                typeEffect={handlerTypeEffect}
                                effectFileNameFor={effectFileNameFor}
                                effectFileNameBehind={effectFileNameBehind}
                                effectClear={effectClear}
                                class_id={data.photo.class_id}
                                folder_id={data.photo.folder.folder_id}
                                user_id={props.user_id}
                                type={1}
                                photoType={0}
                                closePopup={closePopup}/>

                        </CardContent>
                        <ProductDiscountAlert product={product} t={props.t}/>
                        <Card.Footer className="card-footer bg-transparent full-width-margin">
                            <GeneralButton
                                style={{
                                    width: `-webkit-fill-available`
                                }}
                                value={product.product_id}
                                name="addToCart"
                                className="btn btn-secondary"
                                type="submit"
                                endIcon={<AddShoppingCartIcon color="inherit"/>}
                                onClick={(e) => handleCreateShoppingCart(e, product)}
                            >
                                {props.t('shoppage:Add')}
                            </GeneralButton>
                        </Card.Footer>
                    </Grid>
                </Card>
            </Grid>
        )
    } else {

        if ((product.productdetail.product_type === 'pakket' && product.productlink.productpakketdetails[0].products.length !== 0) || product.productdetail.product_type !== 'pakket') {
            return (
                product.productdetail.productcategory.categorie_id === category_id || (category_id === 'adds' && product.productdetail.actie_prijs !== null && product.productdetail.actie_prijs !== 0) ?
                    <Grid container direction="row" key={product.product_id} style={{
                        width: `100%`,
                    }}>
                        <Card
                            className="bg-light bottom-card" style={{
                            width: `100%`,
                        }}
                        >
                            <Grid container direction="row" className="no-full-margin-around">
                                <Grid item xs={6} sm={8} md={8} lg={8} xl={8}
                                      className="text-start"
                                      style={{
                                          backgroundColor: `${background_color_3}`,
                                          color: `${primary_color_3}`
                                      }}>
                                    <CardContent className="card-heading">
                                        <Typography className="font-bold" variant="h6" component="h6">
                                            {product.productdetail.naam}
                                        </Typography>
                                    </CardContent>
                                </Grid>
                                <Grid item xs={6} sm={4} md={4} lg={4} xl={4}
                                      className="text-end"
                                      style={{
                                          backgroundColor: `${background_color_4}`,
                                          color: `${primary_color_5}`
                                      }}>
                                    <CardContent className="card-heading">
                                        <Typography align="right" className="font-bold price" variant="subtitle1"
                                                    component="div">
                                            <ProductPrice price={product.productdetail.prijs} actionprice={product.productdetail.actie_prijs}></ProductPrice>
                                        </Typography>
                                    </CardContent>
                                </Grid>
                            </Grid>
                            <Grid container direction="row">
                                <CardContent className="card-body-and-footer col-12" style={{
                                    width: `100%`,
                                }}>
                                    <ProductDetailComponent
                                        {...props}
                                        updatePhotoFileName={updatePhotoFileName}
                                        modulerights={props.modulerights}
                                        product_id={product.product_id}
                                        product_description={product.productdetail.description}
                                        product_video={product.productdetail.youtube}
                                        pakket_data={product.productlink.productpakketdetails[0].products}
                                        category_id={product.productdetail.productcategory.categorie_id}
                                        product_type={product.productdetail.product_type}
                                        printType={printType}
                                        product_combivel_id={product.productdetail.combivel_id}
                                        product_colors={product.productdetail.kleuren}
                                        photo_file_name={product.productdetail.product_file}
                                        product_image={product.productdetail.afbeelding}
                                        product_format={product.productdetail.product_format}
                                        photo_id={queryVars.photo_id}
                                        session_id={session_id}
                                        handleColorChange={handleColorChange}
                                        changeQuantity={changeQuantity}
                                        productVariation={productVariation}
                                        quantity={quantity}
                                        fileNameEffect={handlerFileNameEffect}
                                        fileIdEffect={handlerFileIdEffect}
                                        typeEffect={handlerTypeEffect}
                                        effectFileNameFor={effectFileNameFor}
                                        effectFileNameBehind={effectFileNameBehind}
                                        effectClear={effectClear}
                                        class_id={data.photo.class_id}
                                        folder_id={data.photo.folder.folder_id}
                                        user_id={props.user_id}
                                        type={1}
                                        photoType={0}
                                        closePopup={closePopup}/>

                                </CardContent>
                                <Grid item xs={12}>
                                    <ProductDiscountAlert product={product} t={props.t}/>
                                </Grid>
                                <CardActions
                                    style={{
                                        width: `100%`
                                    }}
                                    className="card-footer bg-transparent full-width-margin">
                                    {(hide_category_side_bar==='true' && product.productdetail.productcategory.back_categorie!==null) && (
                                    <GeneralButton
                                        fullWidth
                                        style={{
                                            width: `100%`
                                        }}
                                        value={product.product_id}
                                        name="addToCart"
                                        className="btn btn-secondary"
                                        type="submit"
                                        endIcon={<AddShoppingCartIcon color="inherit"/>}
                                        onClick={(e) => handleNotShoppingCart(e, product)}
                                    >
                                        Sla deze over
                                    </GeneralButton>)}
                                    <GeneralButton
                                        fullWidth
                                        style={{
                                            width: `100%`
                                        }}
                                        value={product.product_id}
                                        name="addToCart"
                                        className="btn btn-secondary"
                                        type="submit"
                                        endIcon={<AddShoppingCartIcon color="inherit"/>}
                                        onClick={(e) => handleCreateShoppingCart(e, product)}
                                    >
                                        {hide_category_side_bar === 'true' ? 'Ik wil deze' : props.t('shoppage:Add')}
                                    </GeneralButton>
                                </CardActions>
                            </Grid>
                        </Card>
                    </Grid>
                    :
                    null
            );
        } else {
            return null;
        }
    }

}


export default React.memo(withTranslation(['message', 'shoppage', 'shoppingcart'])(Product));
